import {
    Modal,
    Container,
} from "react-bootstrap";
import React from "react";
import ReactLoading from "react-loading";
import "./Modal.css";

function AddModal(props) {
    const cancel = props.isCancel ? false: true
    return (
        <div>
            <Modal
                show={props.show}
                onHide={props.onHide}
                size={props.size}
                centered
                backdrop="static" 
                keyboard={false}
            >
                {
                    (cancel) && (
                        <Modal.Header closeButton />
                    )
                }
                <Modal.Body>
                    <div className="col-sm-12">
                        <p className="custom-modal-body-title">
                            {" "}
                            ADD {props.title}{" "}
                        </p>
                        <Container
                            fluid
                            className="modal-cont justify-content-center"
                        >
                            {/* {props.type === "supplier" && (AddSupplier())}
              {props.type === "bank" && (AddBank())}
              {props.type === "branch" && (AddBranch())}
              {props.type === "ingredient" && (AddIngredient())}
              {props.type === "product" && (AddProduct())}
              {props.type === "user" && (AddUser())}
              {props.type === "employee" && (AddEmployee())} */}
                            {props.children}
                        </Container>

                        <div className="col-sm-12 mt-3 d-flex justify-content-end">
                           {
                            (cancel) && (
                                <button
                                className="button-secondary me-3"
                                onClick={props.onHide}
                                >
                                    Cancel
                                </button>
                            )
                           }
                            {props.isClicked === true && (
                                <div className="button-primary d-flex justify-content-center">
                                    <ReactLoading
                                        type="bubbles"
                                        color="#FFFFFF"
                                        height={50}
                                        width={50}
                                    />
                                </div>
                            )}
                            {props.isClicked === false && !props.isProceed && (
                                <button
                                    className="button-primary"
                                    onClick={props.onSave}
                                >
                                    Save
                                </button>
                            )}
                            {(props.isProceed && props.isClicked === false) && (
                                <button
                                    className="button-primary w-100"
                                    onClick={props.onSave}
                                >
                                    Proceed
                                </button>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

AddModal.defaultProps = {
    title: "",
    // type:"",
    size: "xl",
    show: () => {},
    onHide: () => {},
    onSave: () => {},
};

export default AddModal;
